const dataRoutesQ1 = {
  isolation: 'isolation',
  chauffage: 'chauffage',
  'renovation-globale': 'renovationGlobale',
  'panneaux-solaires': 'photovoltaïque',
  // Masquer temporairement l'offre "Installation de thermostat" (https://helliosolutions.teamwork.com/app/tasks/27028628)
  // thermostat: 'thermostat',
  'audit-energetique': 'auditEnergetique',
  accessibilite: 'accessibilite',
  'accompagnateur-renov': 'accompagnateurRenov',
  conseil: 'nonRenseigne',
};

export default dataRoutesQ1;
